import { getList, getOne } from './getData'
import { setCreate, setDelete, setUpdate } from './setData'

const groups = {
  namespaced: true,
  state: {
    loading: false,
    listGroups: [],
    listSelectGroups: [],
    idSelected: '',
    groupSelected: {}
  },
  mutations: {
    updateList: (state, list) => {
      state.listGroups = list || []
      state.listSelectGroups = []
      if (list) {
        list.forEach(item => state.listSelectGroups.push({
          text: item.name,
          value: item._id
        }))
      }
    },
    updateOne: (state, one) => {
      state.groupSelected = one
      state.idSelected = one._id
    },
    updateLoading: (state, loading) => state.loading = loading,
    updateClearOne: (state) => {
      state.groupSelected = {}
      state.idSelected = ''
    }
  },
  actions: {
    setInit: async ({ commit }, { idTournament, idPhase }) => await getList(commit, idTournament, idPhase),
    setCreateNew: async ({ commit }, { idTournament, idPhase, group }) => {
      const result = await setCreate(idTournament, idPhase, group)
      commit('tournaments/updateOne', result, { root: true })
    },
    setUpdate: async ({ commit }, { idTournament, idPhase, group }) => {
      const result = await setUpdate(idTournament, idPhase, group)
      commit('tournaments/updateOne', result, { root: true })
    },
    setDelete: async ({ commit }, { idTournament, idPhase, idGroup }) => {
      const result = await setDelete(idTournament, idPhase, idGroup)
      commit('tournaments/updateOne', result, { root: true })
    },
    setOne: async ({ commit }, { idTournament, idPhase, idGroup }) => {
      await getOne(commit, idTournament, idPhase, idGroup)
    },
    setClearOne: ({ commit }) => {
      commit('updateClearOne')
    }
  }
}

export default groups
